import React, { useRef } from 'react';
import useOnClickOutside from '@/hooks/useOnClickOutside';

export default function Dialog({
	isOpen,
	handleOpen,
	children,
	width = '450px',
	height = '250px'
}: {
	isOpen: boolean;
	handleOpen: () => void;
	children: React.ReactNode;
	width?: string;
	height?: string;
}) {
	const dialogRef = useRef(null);

	useOnClickOutside({
		ref: dialogRef,
		handler: () => handleOpen()
	});

	if (!isOpen) return null;

	return (
		<div
			style={{ zIndex: 151 }}
			className="absolute bottom-0 left-0 flex h-screen w-screen items-center justify-center bg-black bg-opacity-30"
		>
			<div
				ref={dialogRef}
				style={{
					width,
					height
				}}
				className="mx-2.5 flex flex-col justify-between gap-4 rounded-2xl border border-dark-grey bg-dm-black px-6 py-5 shadow-lg lg:m-0"
			>
				{children}
			</div>
		</div>
	);
}
